import type { LucideIcon } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/style';

interface CardWithTitleProps {
  title: string;
  titleActions?: React.ReactNode;
  actions?: React.ReactNode;
  hasAlert?: boolean;
  icon?: LucideIcon;
  iconClassName?: string;
  contentClassName?: string;
  className?: string;
}

export function CardWithTitle(props: PropsWithChildren<CardWithTitleProps>) {
  const {
    title,
    titleActions,
    actions,
    hasAlert = false,
    icon: Icon,
    className,
    iconClassName,
    children,
    contentClassName,
  } = props;

  return (
    <div
      className={cn('flex flex-col rounded-lg border border-gray-200 overflow-x-auto', className)}
    >
      <div className="flex items-center justify-between border-gray-200 p-4">
        <div className="flex items-center gap-4 text-base font-medium">
          {hasAlert && <div className="size-3 bg-red-600 rounded-full" />}
          {Icon && <Icon className={iconClassName} />}
          {title}
          {titleActions && <div className="flex items-center gap-2">{titleActions}</div>}
        </div>
        <div className="flex items-center gap-2">{actions}</div>
      </div>
      <div className="border-b border-gray-200" />
      {children && (
        <div className={cn('flex flex-col gap-4 p-4 bg-white', contentClassName)}>{children}</div>
      )}
    </div>
  );
}
